import { Props } from '@components/BlockMapper';
import { Button } from '@components/Button/';
import RichText from '@components/RichText';
import { query, space } from '@design/templateFns';
import styled from 'styled-components';

//Shared styles
import { FC } from 'react';
import {
  ContentWrapper,
  Eyebrow,
  Header,
  StackedItem,
  StyledVerticalLineSeparator,
  Text,
} from '../styles';

const StackedSingle: FC<Props> = (props) => {
  const { eyebrow, header, img, richText, ctaText, ctaUrl } = props;

  return (
    <StackedItem>
      <StyledVerticalLineSeparator />

      <ContentWrapper>
        <ImageBox> {img && <img src={img} />}</ImageBox>

        <ContentContainer>
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          {header && <Header>{header}</Header>}
          <Text>{richText && <RichText richText={richText} />}</Text>
          {ctaUrl && ctaText && (
            <Button arrow={true} variant={'tertiary'} url={ctaUrl} label={ctaText} />
          )}
        </ContentContainer>
      </ContentWrapper>
    </StackedItem>
  );
};

export default StackedSingle;

export const ContentContainer = styled.div<{ $reverse?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  grid-row: 2;
  text-align: center;

  @media screen and (${query.atLeast('desktop')}) {
    margin-top: 0;
    grid-row: ${({ $reverse }) => ($reverse ? 1 : 'unset')};
  }
`;

export const ImageBox = styled.div`
  width: 250px;
  height: 250px;
  margin-bottom: ${space('x8')};

  @media screen and (${query.atLeast('desktop')}) {
    margin-bottom: ${space('x14')};
  }

  img {
    width: 100%;
    height: 100%;
    top: 1px;
    left: 1px;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
    box-sizing: border-box;
  }
`;
